(function ($) {
	$('.content-with-video-inner-video-player-button').on(
		'click',
		function (e) {
			e.preventDefault();
			playVideo(
				$(this).data(),
				$(this).closest('.content-with-video-inner-video-player')
			);
		}
	);

	$('.content-with-video-inner-video-languages button').on(
		'click',
		function (e) {
			e.preventDefault();
			playVideo(
				$(this).data(),
				$(this)
					.closest('.content-with-video-inner-video')
					.find('.content-with-video-inner-video-player')
					.first()
			);
		}
	);

	function playVideo(data, target) {
		let video = '';
		if (typeof data.youtube !== 'undefined') {
			video = '<iframe src="https://www.youtube.com/embed/';
			video += data.youtube + '?autoplay=1';
			video +=
				'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
		} else if (typeof data.vimeo !== 'undefined') {
			video = '<iframe src="https://player.vimeo.com/video/';
			video += data.vimeo + '?autoplay=1&byline=0&portrait=0&badge=0';
			video +=
				'"allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
		} else if (typeof data.file !== 'undefined') {
			video += '<video autoplay playsinline controls>';
			video +=
				'<source src="' + data.file + '" type="' + data.filemime + '">';
			video += '</video>';
		}

		$(target).html(video);
	}
})(jQuery);
